<template>
    <van-popup v-model="show" position="bottom" :style="{ height: '100%' }" closeable>
        <div class="popup-wrapper">
            <div class="popup-title">
                问诊信息预览
            </div>
            <div class="popup-content">
                <div class="info-box">
                    <div class="info-title">基本信息</div>
                    <van-cell-group>
                        <van-cell title="患者类型：" :value="askInfo.isMainland ? '非大陆用户' : '大陆用户'" />
                        <van-cell title="姓名：">
                            {{ getUserAskInfo() }}
                        </van-cell>
                        <van-cell title="身份证：" :value="askInfo.idCard" />
                        <van-cell title="手机号：" :value="askInfo.userMemberMobile" />
                        <van-cell title="所在城市：" :value="askInfo.region.join(' ')" />
                        <van-cell title="有效证件：" class="cell-column" v-if="askInfo.isMainland">
                            <div class="card-imgs">
                                <UploadImgs :fileStr="askInfo.idCardFront" :width="200" :height="128" isPreview
                                    :margin="0" />
                                <UploadImgs :fileStr="askInfo.idCardBack" :width="200" :height="128" isPreview
                                    :margin="0" />
                            </div>
                        </van-cell>
                        <van-cell title="婚姻状况：" :value="askInfo.maritalStatus" />
                        <van-cell title="生育状况：" :value="askInfo.maternityStatus" />
                        <van-cell title="月经史：" :value="askInfo.menstrualHistory" v-if="askInfo.sex === 0" />
                        <van-cell title="疾病史：" :value="askInfo.diseaseHistory" />
                        <van-cell title="手术史或外伤史：" :value="askInfo.operation" />
                        <van-cell title="家族病史：" :value="askInfo.familyHistory" />
                        <van-cell title="药物过敏：" :value="askInfo.drugAllergy" />
                        <van-cell title="食物/接触过敏：" :value="askInfo.foodAllergy" />
                        <van-cell title="辅助检查史：" :value="askInfo.auxiliaryExamination" />
                    </van-cell-group>
                </div>
                <div class="info-box">
                    <div class="info-title">问诊信息</div>
                    <van-cell-group>
                        <van-cell title="病情描述：" class="cell-column">
                            <div>{{ askInfo.askIllness || '-' }}</div>
                        </van-cell>
                        <van-cell v-if="askInfo.showTakeMedicineFeel" title="服药感受：" class="cell-column">
                            <div>{{ askInfo.takeMedicineFeel || '-' }}</div>
                        </van-cell>
                        <van-cell title="相关病情图片/视频：" class="cell-column">
                            <UploadImgs :fileStr="askInfo.askImages" isPreview />
                        </van-cell>
                        <van-cell title="三因问卷：" class="cell-column">
                            <SelectThreeFactors :factorsOne="askInfo.factorsOne" :factorsTwo="askInfo.factorsTwo"
                                :factorsThree="askInfo.factorsThree" :isEdit="false" />
                        </van-cell>
                        <van-cell title="病种：" class="cell-column">
                            <SelectDisease :isEdit="false" :diseaseType="askInfo.diseaseType"
                                :diseaseTypeList="askInfo.diseaseTypeList" />
                        </van-cell>
                        <van-cell title="主诉症状：" class="cell-column">
                            <div class="disease-box">
                                <div class="disease-item"
                                    v-for="(item, index) in getSymptomTreeChildren.filter(item => askInfo.symptomIds.includes(item.code))"
                                    :key="index">
                                    {{ item.name }}
                                </div>
                            </div>
                        </van-cell>
                        <van-cell title="舌诊图片：" class="cell-column">
                            <div class="upload-imgs">
                                <div v-for="(item, index) in [
                                    '眼睑',
                                    '眼睑',
                                    '舌苔',
                                    '舌下脉络'
                                ]" :key="index" class="upload-item">
                                    <div class="upload-title">
                                        <div>
                                            {{ { 0: '左眼', 1: '右眼' }[index] || '' }}
                                        </div>
                                        <div>{{ item }}</div>
                                    </div>
                                    <div class="upload-box">
                                        <UploadImgs :fileStr="askInfo.threeConditionImages[index]" :limit="1" isPreview />
                                    </div>
                                </div>
                            </div>
                        </van-cell>
                    </van-cell-group>
                </div>
                <div class="info-box">
                    <van-cell-group>
                        <van-cell title="备注：" :value="askInfo.remark || '-'" />
                    </van-cell-group>
                </div>
            </div>
            <div class="popup-bottom">
                <van-button class="button-box" @click="onChange">修改信息</van-button>
                <van-button type="info" class="button-box" @click="onSave" :disabled="loading">提交问诊</van-button>
            </div>
        </div>
    </van-popup>
</template>
<script>
import SelectDisease from './selectDisease.vue';
import SelectThreeFactors from './selectThreeFactors.vue';
import { ageTimeFormat, getIdCardInfo, analyzeIDCard, formatteThreeConditionImages } from '@/utils/utils'
import { saveAsk } from '@/api/ask'
import { mapGetters } from 'vuex';
export default {
    name: 'viewAskInfo',
    props: {
        askInfo: {
            type: Object,
            default: () => ({})
        },
        showViewAskInfoPopup: {
            type: Boolean,
            default: false
        },
    },
    components: {
        SelectDisease,
        SelectThreeFactors,
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        ...mapGetters({
            threeFactorsIndependent: 'getThreeFactorsIndependent',
            getSymptomTreeChildren: 'getSymptomTreeChildren'
        }),
        show: {
            get() {
                return this.showViewAskInfoPopup
            },
            set(value) {
                this.$emit("update:showViewAskInfoPopup", value);
            }
        },
    },
    methods: {
        onChange() {
            this.show = false
        },
        async onSave() {
            this.loading = true
            const { userNo, assistantNo, askType, userMemberId, } = this.$route.query
            const { isMainland, idCard, birthday, sex, diseaseTypeList, factorsOne, factorsTwo, factorsThree, region, symptomIds } = this.askInfo
            const params = {
                ...this.askInfo,
                isMainland: isMainland ? 0 : 1, // 是否是大陆
                birthday: !isMainland ? analyzeIDCard(idCard).birthday : birthday,// 生日
                sex: !isMainland ? analyzeIDCard(idCard).sex : sex,// 性别
                province: region[0],
                city: region[1],
                questions: [
                    ...this.threeFactorsIndependent.factorsOne.filter(item => factorsOne.includes(item.questionKewWord)),
                    ...this.threeFactorsIndependent.factorsTwo.filter(item => factorsTwo.includes(item.questionKewWord)),
                    ...this.threeFactorsIndependent.factorsThree.filter(item => factorsThree.includes(item.questionKewWord))
                ], // 三因
                askImages: this.askInfo.askImages || "",// 问诊图片
                threeConditionImages: formatteThreeConditionImages(
                    this.askInfo.threeConditionImages.join(','),
                    true
                ).join(','),// 三因图片
                diseaseTypeList: diseaseTypeList ? diseaseTypeList.split(',').map(Number) : [],//病种
                //
                userNo: userNo,
                doctorAssistantNo: assistantNo,
                doctorNo: assistantNo,
                askType: Number(askType),
                userMemberId,
                askDiseaseList: this.getSymptomTreeChildren.filter(item => symptomIds.includes(item.code)).map(item => ({ code: item.code, name: item.name, type: 1 })),
                isOfflineVisit: 1,
                askIllnessYears: '一年内',
                hospitalName: '润生医荃宜互联网医院'
            }
            // 医生
            if (assistantNo.startsWith('YS')) {
                delete params.doctorAssistantNo
            } else { // 医助
                delete params.doctorNo
            }
            await saveAsk(params)
            this.show = false
            this.loading = false
            this.$router.back()
        },
        getUserAskInfo() {
            // 非大陆用户
            if (this.askInfo.isMainland) {
                return `${this.askInfo.name} ${this.askInfo.sex === 0 ? '女'
                    : this.askInfo.sex === 1
                        ? '男'
                        : ''} ${this.askInfo.birthday
                            ? ageTimeFormat(this.askInfo.birthday) + '岁'
                            : ''}`

            } else {
                return `${this.askInfo.name} ${getIdCardInfo(this.askInfo.idCard).sex} ${getIdCardInfo(this.askInfo.idCard).age + '岁'}`
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.popup-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;

    .popup-title {
        padding: 22px 15px;
        font-size: 19px;
        color: #333;
        text-align: center;
    }

    .popup-content {
        flex: 1;
        overflow-y: auto;
        width: 100%;
        background: #f5f5f5;
        padding-bottom: 20px;
    }

    .popup-bottom {
        height: 84px;
        background: #ffffff;
        box-sizing: border-box;
        padding: 16px 25px;
        display: flex;

        .button-box {
            font-size: 18px;
            border: none;
            border-radius: 8px;
            flex: 1.5;

            &:nth-child(1) {
                flex: 1;
                background: #e6f0fa;
                margin-right: 30px;
                color: #1989fa;
            }
        }
    }
}

.info-box {
    background: #fff;

    +.info-box {
        margin-top: 15px;
    }

    .info-title {
        padding: 20px 16px;
        font-size: 18px;
        color: #333;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .price-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 16px;

        .price-button {
            background: #0082ef;
            border-radius: 4px;
            padding: 5px 18px;
            color: #fff;
            cursor: pointer;
        }

        .price-info {
            color: #666;

            div {
                padding: 10px 0;
                font-size: 16px;
            }
        }
    }


    .base-button {
        background: #eff3fb;
        border-radius: 4px;
        padding: 5px 18px;
        color: #0082ef;
        cursor: pointer;
        font-weight: normal;
    }

    .button-red {
        background: #fff;
        color: red;
    }
}

.upload-imgs {
    width: 100%;
    display: flex;
    padding: 15px 0;
    flex-wrap: wrap;
    justify-content: space-between;

    .upload-item {
        overflow: hidden;
        width: 100px;

        .upload-title {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .upload-box {
            height: 100px
        }
    }


}

:deep(.card-imgs) {
    padding: 10px 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.bottom-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 0px 0px 0px 0px;
    z-index: 10;
    background: #ffffff;

    .bottom-container {
        height: 84px;
        background: #ffffff;
        box-sizing: border-box;
        padding: 16px 25px;
        display: flex;

        .button-box {
            font-size: 18px;
            border: none;
            border-radius: 8px;
            flex: 1.8;

            &:nth-child(1) {
                flex: 1;
                background: #e6f0fa;
                margin-right: 30px;
                color: #1989fa;
            }
        }
    }
}

:deep(.van-nav-bar) {

    .van-nav-bar__left,
    .van-icon {
        font-size: 20px;
    }
}

:deep(.van-cell) {
    .van-cell__title {
        color: #666;
        flex-shrink: 0;
        min-width: 30vw;
        margin-right: 20px;
    }

    .van-cell__value {
        text-align: left;
        flex: 0 1 auto;
        color: #333;
    }

}

:deep(.cell-column) {
    flex-direction: column;

    .van-cell__value {
        padding: 5px 0;
    }
}
</style>